import { withStyles } from '@material-ui/core/styles';
import { memo, SFC } from 'react';
import { compose } from 'redux';
import { styles } from './LoadingSpinner.styles';
import { Props } from './LoadingSpinner';
// import { ThemeWrapper } from './themeProvider';

const enhance = compose<SFC<Props>>(
  memo,
//   ThemeWrapper,
  withStyles(styles),
);

export { enhance };
